import React from 'react';
import Select from 'react-select';

const Typeahead = (props) => {
  return (
    <Select
      options={props.options}
      onChange={(selectedOption) => props.onChange(selectedOption)}
      // onChange={props.onChange} 
      placeholder={props.placeholder || 'Select...'}
      value={props.value}
      isDisabled={props.disabled}
      className="col-sm-12"
      styles={{
        control: (baseStyles, state) => ({
          ...baseStyles,
          height: 45,
        }),
      }}
      theme={(theme) => ({
        ...theme,
        colors: {
          ...theme.colors,
          primary25: 'rgba(95, 15, 64,.2)',
          primary: 'rgba(95, 15, 64,.6)',
          primary50: 'rgba(95, 15, 64,.2)'
        },
      })}
    />
  );
}

export default Typeahead;